<div class="bordered">
	<slot></slot>
	<slot name='icon'/>
</div>



<style type="text/css">
	div.bordered{
		border: 1px solid rgba(255, 255, 255, 0.1);
		box-sizing: border-box;
		border-radius: 4px;
		padding: 10px;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
</style>